import {useMemo} from 'react';
import {useTranslation} from 'react-i18next';
import dayjs from 'dayjs';
import * as css from './BreakCard.css';
import CoffeeCup from '../../../../assets/icons/CoffeeCup';
import {TTimetableItem} from '../../../../redux/timetable/timetable.type';
import BreakCardMenu from './breakCardMenu/BreakCardMenu';
import {clearText} from '../../../../component/textEditor/TextEditorHelpers';
import useDoubleTap from '../../../../hooks/useDoubleTap';

interface BreakCardProps {
    breakItem: TTimetableItem;
    onEdit: () => void;
}

function BreakCard({breakItem, onEdit}: BreakCardProps) {
    const {t} = useTranslation('timetable');
    const {title, description, time, timeEnd} = breakItem;

    const duration = useMemo(() => {
        if(!time || !timeEnd) return null;
        const diff = dayjs.unix(timeEnd).diff(dayjs.unix(time), 'minute');
        return diff > 0 ? diff : null;
    }, [time, timeEnd]);

    const plainDescription = description ? clearText(description) : '';
    const handleDoubleTap = useDoubleTap(onEdit);

    return (
        <css.container onClick={handleDoubleTap}>
            <css.stickerCol>
                <CoffeeCup />
            </css.stickerCol>
            <css.content>
                <css.details>
                    <css.title>{title || t('breakDefault')}</css.title>
                    {plainDescription && <css.subtitle>{plainDescription}</css.subtitle>}
                    {duration !== null && (
                        <css.duration>{t('breakCardDuration', {count: duration})}</css.duration>
                    )}
                </css.details>
                <BreakCardMenu breakItem={breakItem} onEdit={onEdit} />
            </css.content>
        </css.container>
    );
}

export default BreakCard;
